import { Spinner } from '../spinner/spinner';

const ContinuousScrollerDataLoadingIndicator = () => {
  return (
    <div className="flex w-full flex-col items-center justify-center overflow-hidden pt-1">
      <Spinner className="size-5" />
    </div>
  );
};

export default ContinuousScrollerDataLoadingIndicator;
